import { ATOL_DRIVER_ID, findDriver } from './drivers'
import { kassaEnabled } from './kassas'
import { linkPhase } from '@krp/client-runtime'
import { scanRunning } from './scan'
import type { EquipmentSnapshot } from './types'

/**
 * Как часто окно перепроверяет (п. 5.3): чаще, пока человек что-то ставит и ждёт отклика; реже, когда всё работает.
 * Чистые функции: сам опрос ведёт binding приложения.
 */

/** Агента нет (ищем, не найден, связь потеряна): раз в 3 с. */
export const POLL_NO_AGENT_MS = 3_000
/** Агента нет дольше двух минут: человек, скорее всего, не ставит его сейчас — раз в 10 с. */
export const POLL_NO_AGENT_LONG_MS = 10_000
export const NO_AGENT_LONG_AFTER_MS = 120_000
/** Агент на связи, но что-то не готово: раз в 3 с. */
export const POLL_WAITING_MS = 3_000
/** Агент на связи и всё готово: раз в 8 с. */
export const POLL_READY_MS = 8_000
/** Полный просмотр портов раз в 30 с, пока агент на связи: найти второго агента. */
export const FULL_DISCOVERY_EVERY_MS = 30_000

/**
 * Всё готово: драйвер ККТ готов, касса включена и отвечает, драйверы настроенных терминалов готовы, сканирования нет.
 * Драйвер терминала без настроенных терминалов готовности не мешает: терминал магазину не обязателен.
 */
export function everythingReady(snapshot: EquipmentSnapshot): boolean {
  if (linkPhase(snapshot.link, snapshot.now) !== 'connected') return false
  if (findDriver(snapshot, ATOL_DRIVER_ID)?.state !== 'ready') return false
  if (!kassaEnabled(snapshot)) return false
  if (snapshot.device?.connection !== 'ok') return false
  if (scanRunning(snapshot, 'fiscal-register') || scanRunning(snapshot, 'payment-terminal')) return false
  return (snapshot.terminals?.items ?? []).every((item) => findDriver(snapshot, item.kind)?.state === 'ready')
}

/** Через сколько миллисекунд следующий тик. `noAgentSince` — когда агент перестал отвечать (или поиск начался); `null`, если отвечает. */
export function pollDelay(snapshot: EquipmentSnapshot, noAgentSince: number | null): number {
  const phase = linkPhase(snapshot.link, snapshot.now)
  if (phase === 'searching' || phase === 'missing' || phase === 'lost') {
    return noAgentSince !== null && snapshot.now - noAgentSince >= NO_AGENT_LONG_AFTER_MS ? POLL_NO_AGENT_LONG_MS : POLL_NO_AGENT_MS
  }
  return everythingReady(snapshot) ? POLL_READY_MS : POLL_WAITING_MS
}
